"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO_ADDRESS = `0x${'0'.repeat(40)}`;
//# sourceMappingURL=constatnts.js.map